import React from 'react';
import jakob from '../Testimonial/assets/jakob.png';
import jarratt from '../Testimonial/assets/jarratt.jpg';
import pierre from '../Testimonial/assets/pierre.jpg';
import marijn from '../../pages/customers/assets/marijn.jpeg';
import moritz from '../../pages/customers/assets/moritz.jpeg';
import gary from '../../pages/customers/assets/gaspar.jpeg';

const testimonials = [
  {
    name: 'Jakob Bo Storjohann',
    role: 'CEO',
    company: 'Ideanote',
    quote: `“Hyperping nails all aspects: from smooth setup to peace of mind and attentive customer service.“`,
    portrait: jakob,
  },
  {
    name: 'Pierre Renaudin',
    role: 'CTO',
    company: 'Slite',
    quote: `“We picked Hyperping to bring a high quality incidents and status reporting dashboard to our users.”`,
    portrait: pierre
  },
  {
    name: 'Jarratt Isted',
    role: 'Co-Founder',
    company: 'HelpDocs',
    quote: `“With realtime data built right in we can make sure we're delivering a fantastic experience across our whole platform.”`,
    portrait: jarratt
  },
  {
    name: 'Marijn',
    role: 'CEO',
    company: 'mijn.host',
    quote: `“What sets Hyperping apart is its customisation capabilities and real-time updates.”`,
    portrait: marijn
  },
  {
    name: 'Moritz Dausinger',
    role: 'CEO',
    company: 'Refiner',
    quote: `“What we absolutely love about Hyperping is their beautifully designed status page.”`,
    portrait: moritz
  },
  {
    name: 'Gary Gaspar',
    role: 'CEO',
    company: 'Marker.io',
    quote: `“We couldn't imagine running our SaaS business without Hyperping now.”`,
    portrait: gary
  },
]

const Testimonials = ({ title = (<>They chose Hyperping because of our<br/>reliability and great experience</>), allTestimonials = testimonials, width = 300 }) => {
  return (
  <>
  <div className="flex gap-05em flex-direction-column align-items-center">
    <div className="testimonial-accent">What people are saying</div>
    {/* <div className="color-text flex width-fit-content padding-025em font-weight-400 font-size-14px border mb-05em" style={{background:'black',lineHeight:'20px',borderRadius:'20px',paddingLeft:'0.75em',paddingRight:'0.75em'}}>What people are saying</div> */}
    <h3 className="testimonial-h3 line-height-115em font-weight-500 mb-1em" style={{fontSize: '38px'}}>{title}</h3>
  </div>
  <div className="testimonials" style={{
    gridTemplateColumns: `repeat(auto-fit, minmax(${width}px, 1fr))`
  }}>
    {allTestimonials.map(testimonial => (<div key={testimonial.name} className="testimonial">
      <p>{testimonial.quote}</p>
      <div className="who">
        <div className="name-title">
          <div className="name">{testimonial.name}</div>
          <div className="role">{testimonial.role}, {testimonial.company}</div>
        </div>
        <img src={testimonial.portrait} />
      </div>
    </div>))}
  </div></>);
};

export default Testimonials;
